export const LIST_OF_GENERAL_FLEET_DETAIL_SUCCESS =
  "LIST_OF_GENERAL_FLEET_DETAIL_SUCCESS";
export const LIST_OF_GENERAL_FLEET_DETAIL_ERROR =
  "LIST_OF_GENERAL_FLEET_DETAIL_ERROR";
export const LIST_OF_GENERAL_FLEET_DETAIL_START =
  "LIST_OF_GENERAL_FLEET_DETAIL_START";

export const LIST_OF_LEGEL_FLEET_DETAIL_SUCCESS =
  "LIST_OF_LEGEL_FLEET_DETAIL_SUCCESS";
export const LIST_OF_LEGEL_FLEET_DETAIL_ERROR =
  "LIST_OF_LEGEL_FLEET_DETAIL_ERROR";
export const LIST_OF_LEGEL_FLEET_DETAIL_START =
  "LIST_OF_LEGEL_FLEET_DETAIL_START";

export const LIST_OF_FINANCE_FLEET_DETAIL_SUCCESS =
  "LIST_OF_FINANCE_FLEET_DETAIL_SUCCESS";
export const LIST_OF_FINANCE_FLEET_DETAIL_ERROR =
  "LIST_OF_FINANCE_FLEET_DETAIL_ERROR";
export const LIST_OF_FINANCE_FLEET_DETAIL_START =
  "LIST_OF_FINANCE_FLEET_DETAIL_START";

export const GENERAL_VIEW_LIST_SUCCESS = "GENERAL_VIEW_LIST_SUCCESS";
export const GENERAL_VIEW_LIST_ERROR = "GENERAL_VIEW_LIST_ERROR";
export const GENERAL_VIEW_LIST_START = "GENERAL_VIEW_LIST_START";

export const LEGAL_VIEW_LIST_SUCCESS = "LEGAL_VIEW_LIST_SUCCESS";
export const LEGAL_VIEW_LIST_ERROR = "LEGAL_VIEW_LIST_ERROR";
export const LEGAL_VIEW_LIST_START = "LEGAL_VIEW_LIST_START";

export const SAVE_GENRAL_FLEET_REQUEST = "SAVE_GENRAL_FLEET_REQUEST";
export const SAVE_GENRAL_FLEET_SUCCESS = "SAVE_GENRAL_FLEET_SUCCESS";
export const SAVE_GENRAL_FLEET_ERROR = "SAVE_GENRAL_FLEET_ERROR";

export const SAVE_LEGAL_FLEET_START = "SAVE_LEGAL_FLEET_START";
export const SAVE_LEGAL_FLEET_SUCCESS = "SAVE_LEGAL_FLEET_SUCCESS";
export const SAVE_LEGAL_FLEET_ERROR = "SAVE_LEGAL_FLEET_ERROR";
export const ClEAR_ALL_DATA = "ClEAR_ALL_DATA";
